import { render } from "./Wheel.vue?vue&type=template&id=d050796e&scoped=true"
import script from "./Wheel.vue?vue&type=script&lang=js"
export * from "./Wheel.vue?vue&type=script&lang=js"

import "./Wheel.vue?vue&type=style&index=0&id=d050796e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d050796e"]])

export default __exports__